import axios from 'axios';
import { alertRef } from '../App';
import store from '../redux/store';
import { setLanguage } from '../redux/reducers/tableorder';

export const isLogin = async () => {
    try{
        const data = await axios.get('/api/session')
        
        if(data.status === 200) return true
        else return false
    }
    catch{
        return false
    }
}

export const tableOrderSync = async () => {
    try{
        const data = await axios.post('/api/table/order/sync/menu')
        if(data.status === 204) {
            alertRef.current.showAlert({ title: '메뉴 동기화가 완료되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            return true;
        }
        else {
            alertRef.current.showAlert({ title: '메뉴 동기화에 실패했어요. 다시 시도해주세요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            return false;
        }
    }
    catch {
        alertRef.current.showAlert({ title: '메뉴 동기화에 실패했어요. 다시 시도해주세요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
        return false;
    }
}

export const getLanguage = (type) => {
    axios.get(`/api/${type}/order/info/language`)
    .then((data) => {
        if(type === 'hotel' && typeof data.data.HotelOrderInfo.language !== 'undefined')
            store.dispatch(setLanguage(data.data.HotelOrderInfo.language))
        else if(type === 'table' && typeof data.data.TableOrderInfo.language !== 'undefined')
            store.dispatch(setLanguage(data.data.TableOrderInfo.language))
        else if(type === 'pickup' && typeof data.data.TableOrderInfo.language !== 'undefined')
            store.dispatch(setLanguage(data.data.TableOrderInfo.language))
    })
}

export const translation = (language, text) => {
//   alert(`번역중입니다..`);
  const return_translation = language.map(item => (
    {language: item, text: text.map(element => `${element}_${item}`)}
  ));
  return return_translation;
};

export const support_language = [
    {value: 'en', text:'영어'},
    {value: 'zh-Hans', text:'중국어'},
    {value: 'ja', text:'일본어'},
]